import axios from 'axios';

const api = axios.create({
baseURL: 'https://vktrend-backend-cf4851.rivendeploy.com/api',
withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

/* ═══════════════════════════════════════════
   Request Interceptor
═══════════════════════════════════════════ */
api.interceptors.request.use((config) => {
  const csrfToken = getCookie('csrftoken');
  if (csrfToken) config.headers['X-CSRFToken'] = csrfToken;

  const token = localStorage.getItem('access_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;

  return config;
});

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

/* ═══════════════════════════════════════════
   AUTH
═══════════════════════════════════════════ */
export const loginUser         = (data) => api.post('/accounts/login/', data);
export const logoutUser        = ()     => api.post('/accounts/logout/');
export const getMe             = ()     => api.get('/accounts/me/');
export const sendRegisterOTP   = (data) => api.post('/accounts/register/send-otp/', data);
export const verifyRegisterOTP = (data) => api.post('/accounts/register/verify-otp/', data);
export const googleLogin       = (data) => api.post('/accounts/google/', data);

/* ═══════════════════════════════════════════
   CATALOGUE
═══════════════════════════════════════════ */
export const getCategories = ()              => api.get('/categories/');
export const getProducts   = (params = {})   => api.get('/products/', { params });
export const getProduct    = (slug)          => api.get(`/products/${slug}/`);

/* ═══════════════════════════════════════════
   CART
═══════════════════════════════════════════ */
export const getCart      = ()         => api.get('/cart/');
export const addToCart    = (data)     => api.post('/cart/add/', data);
export const updateItem   = (id, data) => api.patch(`/cart/update/${id}/`, data);
export const removeItem   = (id)       => api.delete(`/cart/remove/${id}/`);
export const clearCart    = ()         => api.post('/cart/clear/');
export const mergeCartAPI = (items)    => api.post('/cart/merge/', { items });

/* ═══════════════════════════════════════════
   WISHLIST
═══════════════════════════════════════════ */
export const getWishlistAPI    = ()           => api.get('/wishlist/');
export const addToWishlistAPI  = (productId)  => api.post('/wishlist/add/',    { product_id: productId });
export const removeWishlistAPI = (productId)  => api.post('/wishlist/remove/', { product_id: productId });
export const toggleWishlistAPI = (productId)  => api.post('/wishlist/toggle/', { product_id: productId });
export const mergeWishlistAPI  = (productIds) => api.post('/wishlist/merge/',  { product_ids: productIds });

/* ═══════════════════════════════════════════
   ORDERS
═══════════════════════════════════════════ */
export const getOrders            = ()              => api.get('/orders/');
export const placeOrder           = (data)          => api.post('/orders/', data);
export const getOrderByNumber     = (orderNumber)   => api.get(`/orders/${orderNumber}/`);
export const cancelOrderByNumber  = (orderNumber)   => api.post(`/orders/${orderNumber}/cancel/`);
export const submitReturnRequest  = (orderNumber, data) =>
  api.post(`/orders/${orderNumber}/return/`, data);
export const getMyReturns         = ()              => api.get('/orders/returns/');

// Backward compatibility (purane routes id-based the)
export const getOrder     = (id) => api.get(`/orders/${id}/`);
export const cancelOrder  = (id) => api.post(`/orders/${id}/cancel/`);

/* ═══════════════════════════════════════════
   REVIEWS
═══════════════════════════════════════════ */
export const getReviews   = (pid)       => api.get(`/reviews/${pid}/`);
export const addReview    = (pid, data) => api.post(`/reviews/${pid}/`, data);
export const deleteReview = (pid)       => api.delete(`/reviews/${pid}/delete/`);

export const uploadReviewImage = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post('/reviews/upload/', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/* ═══════════════════════════════════════════
   PAYMENTS
═══════════════════════════════════════════ */
export const makePayment = (data) => api.post('/payments/', data);

/* ═══════════════════════════════════════════
   DASHBOARD (Banners, Gender Cards, Site Settings)
═══════════════════════════════════════════ */
export const getGenderCards  = () => api.get('/dashboard/gender-cards/');
export const getSiteSettings = () => api.get('/dashboard/site-settings/');

export const getBanners = (params = {}) =>
  api.get('/dashboard/banners/', { params });

export default api;